import React, { useState } from "react";
import TabHeader from "../components/TabHeader";
import Dashboard from "./orders-inventory/Dashboard";
import SupplierManagement from "./orders-inventory/SupplierManagement";
import OrderManagement from "./orders-inventory/OrderManagement";
import MerchantManagement from "./orders-inventory/MerchantManagement";
import InventoryMovement from "./orders-inventory/InventoryMovement";
import AuditLogs from "./orders-inventory/AuditLogs";
import UserAccess from "./orders-inventory/UserAccess";
import ItemMaster from "./orders-inventory/ItemMaster";

const OrdersInventory = () => {
    const [activeTab, setActiveTab] = useState("dashboard");
    const [orderManagementViewOrderId, setOrderManagementViewOrderId] = useState(null);

    const tabs = [
        { id: "dashboard", label: "Dashboard", icon: require("../icons/inventory/dashboard.png") },
        { id: "merchant-management", label: "Merchant Management", icon: require("../icons/inventory/merchant-management.png") },
        { id: "supplier-management", label: "Supplier Management", icon: require("../icons/inventory/supplier-management.png") },
        { id: "order-management", label: "Order Management", icon: require("../icons/inventory/order-management.png") },
        { id: "inventory-movement", label: "Inventory Movement", icon: require("../icons/inventory/inventory-movement.png") },
        { id: "item-master", label: "Item Master", icon: require("../icons/inventory/item-master.png") },
        { id: "audit-logs", label: "Audit Logs", icon: require("../icons/inventory/audit-logs.png") },
        { id: "user-access", label: "User Access", icon: require("../icons/inventory/user-access.png") },
    ];

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div className="mainContainer">
            <TabHeader 
                tabs={tabs} 
                activeTab={activeTab} 
                onTabChange={handleTabChange} 
            />
            {activeTab === "dashboard" && (
                <Dashboard
                    onViewOrder={(orderId) => {
                        if (!orderId) return;
                        setOrderManagementViewOrderId(orderId);
                        setActiveTab("order-management");
                    }}
                />
            )}
            {activeTab === "merchant-management" && (
                <MerchantManagement />
            )}
            {activeTab === "supplier-management" && (
                    <SupplierManagement />
            )}
            {activeTab === "order-management" && (
                    <OrderManagement
                        initialViewOrderId={orderManagementViewOrderId}
                        onConsumedInitialViewOrder={() => setOrderManagementViewOrderId(null)}
                    />
            )}
            {activeTab === "inventory-movement" && (
                    <InventoryMovement />
            )}
            {activeTab === "audit-logs" && (
                    <AuditLogs />
            )}
            {activeTab === "user-access" && (
                    <UserAccess />
            )}
            {activeTab === "item-master" && (
                    <ItemMaster />
            )}
            {activeTab !== "dashboard" && activeTab !== "merchant-management" && activeTab !== "supplier-management" && activeTab !== "order-management" && activeTab !== "inventory-movement" && activeTab !== "audit-logs" && activeTab !== "user-access" && activeTab !== "item-master" && (
                <div className="dashboard-content">
                    <div className="dashboard-header">
                        <h1 className="dashboard-title">{tabs.find(t => t.id === activeTab)?.label || "Page"}</h1>
                    </div>
                </div>
            )}
        </div>
    );
}

export default OrdersInventory;

